import { render } from "./MenuInputGroup.vue?vue&type=template&id=5b075966&scoped=true"
import script from "./MenuInputGroup.vue?vue&type=script&lang=ts"
export * from "./MenuInputGroup.vue?vue&type=script&lang=ts"

import "./MenuInputGroup.vue?vue&type=style&index=0&id=5b075966&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5b075966"

export default script